export default "/fonts/vendor/@fontsource/inter/files/inter-latin-ext-400-normal.woff2?325ea6d33179f07ec7db802af3e3916e";